<template>
  <el-container style="width:100%; height:100vh">
    <el-header style="background-color: white; box-shadow: 0 0 2px rgba(0, 0, 0, 0.2); box-sizing: border-box" class="row">
      <input class="input-box" v-model="query" placeholder="输入您想查询的岗位信息"/>
      <button class="search-button row"><el-icon><Search /></el-icon><span style="margin-left:5px">搜索</span></button>
    </el-header>
    <el-main style="background-color: white" class="row-center">
      <div style="width:40%; margin-left:30%">
        <el-upload class="upload-demo" drag action="/files/upload" multiple>
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">
            文件拖至此处 或 <em>点击上传</em>
          </div>
        </el-upload>
      </div>




    </el-main>
  </el-container>
</template>
<script setup>
import {ref} from "vue";
import { UploadFilled } from '@element-plus/icons-vue'
const query = ref("");

</script>
<style scoped>

.input-box{
  font-size:14px;
  padding: 12px;
  border: 1px solid lightgray;
  outline: none;
  width:40%;
  height:45px;
  border-radius:30px 0px 0px 30px;
}

.search-button{
  border-radius:0px 30px 30px 0px;
  margin-left:0px;
  font-size:15px;
  height:45px;
  padding: 12px 20px;
  background-color: #6467F0;
  color: white;
  border:none;
}

.input-box:hover{
  border: 1px solid #6467F0;
  outline: none;

}
</style>
